import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const LeafIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M3.9558 14.653C3.89329 14.8106 3.98768 14.9868 4.15572 15.0093C6.37462 15.3065 9.37946 14.0947 12.1025 11.3717C15.545 7.92916 14.9998 0.999944 14.9998 0.999944C14.9998 0.999944 8.07474 0.458866 4.63217 3.90144C1.9578 6.57581 0.741126 9.52205 0.980109 11.7286C1.00031 11.9151 1.22561 11.9811 1.35471 11.8449C3.75627 9.31167 6.67803 7.32865 9.91905 6.03225L9.99982 5.99994C7.371 8.30015 5.32803 11.1936 4.04009 14.4405L3.9558 14.653Z"
		/>
	</svg>
))
